/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectSuitableStagesQueryResult } from '../../models/get-project-suitable-stages-query-result';

export interface ApiProjectStagesGetProjectSuitableStagesGet$Params {
  ProjectId: string;
  PathId: string;
}

export function apiProjectStagesGetProjectSuitableStagesGet(http: HttpClient, rootUrl: string, params: ApiProjectStagesGetProjectSuitableStagesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectSuitableStagesQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectStagesGetProjectSuitableStagesGet.PATH, 'get');
  if (params) {
    rb.query('ProjectId', params.ProjectId, {});
    rb.query('PathId', params.PathId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectSuitableStagesQueryResult>;
    })
  );
}

apiProjectStagesGetProjectSuitableStagesGet.PATH = '/api/ProjectStages/GetProjectSuitableStages';
